/* Jendco Request-a-Quote — entry point controller (brief §5.1)
 * PDP: APPENDS product to existing localStorage list (merge by variant_id).
 *      Multiple PDPs can be visited; each adds to the quote.
 * Cart: REPLACES list with all current cart items (snapshot).
 * Both navigate to the form after writing.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'jendco_quote_items';
  var FORM_URL    = '/pages/quote-request-page';

  document.addEventListener('DOMContentLoaded', function () {
    wirePDP();
  });

  /* ─── PDP — append / merge by variant_id ────────────────────────────── */
  function wirePDP() {
    document.querySelectorAll('[data-quote-request-pdp]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        var qty = 1;
        var form = btn.closest('.product-form, [data-type="add-to-cart-form"]');
        var qtyInput = form
          ? form.querySelector('.quantity__input')
          : document.querySelector('.quantity__input');
        if (qtyInput) qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

        var newItem = {
          variant_id: variantId,
          title:      btn.getAttribute('data-product-title'),
          sku:        btn.getAttribute('data-product-sku'),
          image:      btn.getAttribute('data-product-image'),
          qty:        qty
        };

        /* Merge: if same variant already in list, add qty; else append */
        var existing = getItems();
        var found = false;
        existing = existing.map(function (item) {
          if (item.variant_id === variantId) {
            found = true;
            return Object.assign({}, item, { qty: item.qty + qty });
          }
          return item;
        });
        if (!found) existing.push(newItem);

        writeAndGo(existing);
      });
    });
  }

  /* ─── Grid card — append / merge single product by variant_id ───────── */
  document.addEventListener('click', function (e) {    
    var link = e.target.closest('[data-quote-request-grid]');
    if (!link) return;
    e.preventDefault();

    var variantId = link.getAttribute('data-variant-id') || '';
    var newItem = {
      variant_id: variantId,
      title:      link.getAttribute('data-product-title') || '',
      sku:        link.getAttribute('data-product-sku') || '',
      image:      link.getAttribute('data-product-image') || '',
      qty:        1
    };

    var existing = getItems();
    var found = false;
    existing = existing.map(function (item) {
      if (item.variant_id === variantId) {
        found = true;
        return Object.assign({}, item, { qty: item.qty + 1 });
      }
      return item;
    });
    if (!found) existing.push(newItem);
    writeAndGo(existing);
  });

  /* ─── Cart — replace with full cart snapshot ─────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quote-request-cart]');
    if (!btn) return;

    if (btn.dataset.quoteLoading) return;
    btn.dataset.quoteLoading = '1';

    var label = btn.querySelector('.btn__text');
    if (label) label.textContent = 'Loading…';
    btn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (item) {
          return {
            variant_id: String(item.variant_id),
            title: item.product_title + (
              item.variant_title && item.variant_title !== 'Default Title'
                ? ' — ' + item.variant_title : ''
            ),
            sku:   item.sku || '',
            image: item.featured_image && item.featured_image.url
              ? item.featured_image.url : '',
            qty:   item.quantity
          };
        });
        writeAndGo(items);  /* cart always replaces — full snapshot */
      })
      .catch(function () {
        delete btn.dataset.quoteLoading;
        btn.disabled = false;
        if (label) label.textContent = 'Request Quote';
        alert('Could not load cart. Please try again.');
      });
  });

  /* ─── Helpers ─────────────────────────────────────────────────────────── */
  function getItems() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function writeAndGo(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
    catch (e) {}
    window.location.href = FORM_URL;
  }

})();
